export class ContentFilterModel {
  public createdDateFrom: string;
  public createdDateTo: string;
  modifiedDateFrom: string;
  modifiedDateTo: string;

  constructor(
    createdDateFrom: string,
    createdDateTo: string,
    modifiedDateFrom: string,
    modifiedDateTo: string
  ) {
    this.createdDateFrom = createdDateFrom;
    this.createdDateTo = createdDateTo;
    this.modifiedDateFrom = modifiedDateFrom;
    this.modifiedDateTo = modifiedDateTo;
  }
}
